import React from 'react';
import { InsidePagesCarousel } from '../InsidePagesCarousel';
import { Accent, SectionHeading } from './SectionHeading';
export function InsideSection() {
  return <section aria-labelledby="inside-heading" className="bg-brand-ivory px-5 py-16 lg:px-8 lg:py-20" data-id="element-117" data-mp="2lzhgzrni1l58">
      <div className="mx-auto max-w-6xl" data-id="element-118" data-mp="2h427td0fsdf5">
        <SectionHeading id="inside-heading" title={<>
              See What <Accent data-id="element-120" data-mp="286rr3c4unw2u">“Ready-to-Teach”</Accent> Actually Looks Like.
            </>} body="Visual explanations. Professional frameworks. Classroom-ready resources. No starting from a blank page." data-id="element-119" data-mp="2d3s0nx0wrgyp" />

        <div className="mt-12" data-id="element-121" data-mp="1y82i68uxllyq">
          <InsidePagesCarousel data-id="element-122" data-mp="1u5ywysign309" />
        </div>

        <p className="mt-6 text-center font-body text-[13px] italic text-brand-charcoal/55" data-id="element-123" data-mp="1u7ab9m9j7t5m">
          Real pages from Volume 2 of Cosmetology Instructor Ready™
        </p>
      </div>
    </section>;
}